import { render, staticRenderFns } from "./company-saved-search.vue?vue&type=template&id=76a2c6c1&"
import script from "./company-saved-search.vue?vue&type=script&lang=js&"
export * from "./company-saved-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports